import apiClient from 'lib/apiClient';

export const getBlogs = (query = {}) => {
  return apiClient.get('API/1_0/blogPost.php', {
    params: {
      order_by: 'post_create_date',
      sort_dir: 'desc',
      ...query,
    },
  });
};

export const getPost = (hash) => {
  return apiClient
    .get('API/1_0/blogPost.php', {
      params: {
        hash,
      },
    })
    .then((r) => r[0]);
};

export const getPostBySlug = (slug) => {
  return apiClient
    .get('API/1_0/blogPost.php', {
      params: {
        post_permalink: slug,
      },
    })
    .then((r) => r[0]);
};

export const createBlog = (data) =>
  apiClient.post('API/1_0/blogPost.php', data);

export const deletePost = (id) =>
  apiClient.delete(`API/1_0/blogPost.php`, { params: { hash: id } });
